import { Geometry } from '@babylonjs/core/Meshes/geometry';
import { type Scene } from '@babylonjs/core/scene';
import { type VertexDataDesc } from './meshTypes';
import { vertexDataCreate } from './vertexData';

/**
 * Creates geometry from descriptor.
 * @param id - Unique ID.
 * @param scene - Hosting scene.
 * @param data - Vertex data descriptor.
 * @param isUpdatable - If geometry must be updatable.
 */
export const geometryCreate = (
  id: string,
  scene: Scene,
  data: VertexDataDesc,
  isUpdatable = false,
): Geometry => {
  const vertexData = vertexDataCreate(data);
  const result = new Geometry(id, scene, vertexData, isUpdatable);
  return result;
};

export const removeVerticesDataWithNotify = (geometry: Geometry, kind: string) => {
  geometry.removeVerticesData(kind);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- Hidden function call
  (geometry as any)._notifyUpdate(kind);
};
